import { ReactComponent as CheckBoxActiveIcon } from '../../assets/icons/radio-active-icon.svg';
import { ReactComponent as CheckBoxIcon } from '../../assets/icons/radio-button-icon.svg';
import { TooltipIcon } from '../tooltip/TooltipIcon';

interface CustomCheckInputProperties {
  inputLabel?: string;
  value: string | number | undefined;
  name: string;
  list: { label: string; value: string | number }[];
  onChangeValue?: (name: string, value: string | number) => void;
  valueRequired?: boolean;
  isDisabled?: boolean;
  error?: boolean;
  errorMessage?: string;
  requiredTooltip?: boolean;
  tooltipText?: string;
  fontSize?: 'small' | 'medium' | 'big' | 'large';
}

// To-do -> This should be re-designed as single checkbox component, instead of mapping over list of items
/**
 * Check box buttons function component
 * @param {any} param0 - The param0
 * @param {any} param0.inputLabel - The inputLabel prop
 * @param {any} param0.name - The name prop
 * @param {any} param0.value - The value prop
 * @param {any} param0.list - The list prop
 * @param {any} param0.onChangeValue - The onChangeValue prop
 * @param {any} param0.valueRequired - The valueRequired prop
 * @param {any} param0.isDisabled - The isDisabled prop
 * @param {any} param0.error - The error prop
 * @param {any} param0.errorMessage - The errorMessage prop
 * @param {any} param0.requiredTooltip - The requiredTooltip prop
 * @param {any} param0.tooltipText - The tooltipText prop
 * @param {any} param0.fontSize - The fontSize prop
 * @returns {any} The rendered radio button component
 */
function RadioButton({
  inputLabel,
  name,
  value,
  list,
  onChangeValue,
  valueRequired,
  isDisabled,
  error,
  errorMessage,
  requiredTooltip,
  tooltipText,
  fontSize = 'small',
}: Readonly<CustomCheckInputProperties>) {
  /**
   * check box button handle function
   * @param {any} changeValue - The changeValue
   */
  const handleValueChange = (changeValue: string | number) => {
    if (isDisabled) return;
    if (onChangeValue) {
      onChangeValue(name, changeValue);
    }
  };

  return (
    <div className={`check-box-button-wrap ${fontSize}`}>
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
          {requiredTooltip && tooltipText && <TooltipIcon text={tooltipText} />}
        </p>
      )}
      <div className="custom-check-box">
        <div className="check-box-list">
          {list.map((checkbox) => (
            <div
              key={String(checkbox.value)}
              className={`check-box-item ${isDisabled ? 'disabled' : ''}`}
              onClick={() => handleValueChange(checkbox.value)}
              role="presentation">
              {isDisabled ? (
                <div className="check-box-icon-disabled">
                  {value === checkbox.value ? <CheckBoxActiveIcon /> : <CheckBoxIcon />}
                </div>
              ) : (
                <div className="check-box-icon">
                  {value === checkbox.value ? <CheckBoxActiveIcon /> : <CheckBoxIcon />}
                </div>
              )}
              {/* <div className="check-box-icon">
                {value === checkbox.value ? <CheckBoxActiveIcon /> : <CheckBoxIcon />}
              </div> */}
              <div className={`check-box-label ${fontSize}`}>{checkbox.label}</div>
            </div>
          ))}
        </div>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

RadioButton.defaultProps = {
  inputLabel: '',
  onChangeValue: undefined,
  valueRequired: false,
  isDisabled: false,
  error: false,
  errorMessage: '',
  requiredTooltip: false,
  tooltipText: false,
  fontSize: 'small',
};

export default RadioButton;
